import { values } from 'lodash'

export const NOTIFICATION_SETTINGS_TYPE = {
  dailyRaces: 'dailyRaces',
  facmEnd: 'facmEnd',
  facmReschedule: 'facmReschedule',
  facmStart: 'facmStart',
  rescueGDH: 'rescueGDH',
}

export const NOTIFICATION_SETTINGS_TYPE_ARRAY = values(NOTIFICATION_SETTINGS_TYPE)
